const BREAKPOINTS = {
  MEDIUM: 500
};
export {
  BREAKPOINTS
};
//# sourceMappingURL=globals.js.map
